import React, { useState, useContext } from "react";
import classNames from "classnames";
import { useForm } from "react-hook-form";
import { AppLoad } from "../../../core/AppLoad";
import { useHistory, Link } from "react-router-dom";
import { AppStateContext, AppConfig } from "../../../app-state";
import { NavbarBackHome } from "../../common/header-and-footer/NavbarBackHome";
import { FormGroup } from "../../../core/Form";
import { Icon } from "../../../core/Icon";
export const Login = (props) => {
    const { state, dispatch } = useContext(AppStateContext);
    const [isLoading, updateLoading] = useState(false);
    const [loginResponse, updateLoginResponse] = useState(null);
    const { register, handleSubmit, errors, setValue } = useForm();
    let history = useHistory();
    const onSubmit = (data) => {
        updateLoading(true);
        AppLoad(AppConfig.APIUrl + 'public/auth/login', data).then((Response) => {
            if (Response.status == 'invalid') {
                if (Response.unsuccessful_tries > 5) {
                    updateLoginResponse('locked');
                }
                else {
                    updateLoginResponse('invalid');
                }
                setValue("password", "");
            }
            else if (Response.status == 'ok') {
                dispatch({ type: 'authCheckLogged', payload: Response.userData });
                history.push('/cs/seznam/nejblizsi-aukce');
            }
            updateLoading(false);
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(NavbarBackHome, null),
        React.createElement("div", { className: "process-master-challenge" },
            React.createElement("div", { className: "login-challenge" },
                React.createElement("h1", null, "P\u0159ihl\u00E1\u0161en\u00ED do syst\u00E9mu elektronick\u00FDch aukc\u00ED"),
                loginResponse == 'invalid' && React.createElement("div", { className: "alert error" }, "Kombinace zadan\u00E9ho emailu a hesla neexistuje."),
                loginResponse == 'locked' && React.createElement("div", { className: "alert error" }, "Zaznamenali jsme p\u0159\u00EDli\u0161 mnoho nezda\u0159en\u00FDch pokus\u016F o p\u0159ihl\u00E1\u0161en\u00ED. Z bezpe\u010Dnostn\u00EDch d\u016Fvod\u016F je v\u00E1\u0161 \u00FA\u010Det uzam\u010Den, zkuste se pros\u00EDm p\u0159ihl\u00E1sit pozd\u011Bji."),
                React.createElement("form", { onSubmit: handleSubmit(onSubmit), className: "form", "aria-label": "P\u0159ihla\u0161ovac\u00ED formul\u00E1\u0159" },
                    React.createElement(FormGroup, { id: "email", cssWrapper: "large", label: "Emailov\u00E1 adresa", error: errors.email && 'Prosím vyplňte' },
                        React.createElement("div", { className: "input-with-icon" },
                            React.createElement(Icon, { c: ['mail', 16, 16] }),
                            React.createElement("input", { className: "textfield", id: "email", ref: register({ required: true }), name: "email", type: "text" }))),
                    React.createElement(FormGroup, { id: "password", cssWrapper: "large", label: "Heslo", error: errors.password && 'Prosím vyplňte' },
                        React.createElement("div", { className: "input-with-icon" },
                            React.createElement(Icon, { c: ['lock', 16, 16] }),
                            React.createElement("input", { className: "textfield lock-ico", id: "password", ref: register({ required: true }), name: "password", type: "password" }))),
                    React.createElement("div", { className: "btn-wrap" },
                        React.createElement(Link, { className: "hyperlink", to: "/cs/proces/zapomenute-heslo" }, "Zapomenut\u00E9 heslo?"),
                        React.createElement("button", { type: "submit", className: classNames("primary-button", { "is-busy": isLoading }) },
                            React.createElement("span", { className: "text" }, "P\u0159ihl\u00E1sit se"),
                            React.createElement("span", { className: "spinner", "aria-hidden": true })))),
                React.createElement("div", { className: "utils" },
                    "Pokud je\u0161t\u011B \u00FA\u010Det nem\u00E1te, m\u016F\u017Eete se ",
                    React.createElement(Link, { className: "hyperlink", to: "/cs/proces/registrace" }, "zaregistrovat"),
                    ". S jedn\u00EDm \u00FA\u010Dtem je mo\u017En\u00E9 se \u00FA\u010Dastnit v\u0161ech aukc\u00ED. Pro ka\u017Edou novou aukci v\u00E1m bude p\u0159id\u011Blen nov\u00E9 \u00FA\u010Dastnick\u00E9 \u010D\u00EDslo pro zachov\u00E1n\u00ED anonymity.")))));
};
